export default "<p>\n  <button (click)=\"checkNFC()\">Check</button>\n</p>\n";